import styled from 'styled-components';

export interface PercentProps {
  percent: number;
}

export const Container = styled.div`
  width: 100%;
  height: 40px;
  background: ${({ theme }) => theme.colors.gray_75};
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  @media (max-width: 960px) {
    height: 20px;
  }
`;

export const Progress = styled.div<PercentProps>`
  background-color: ${({ theme }) => theme.colors.warning};
  height: 100%;
  width: ${({ percent }) => percent}%;
  border-radius: 6px;
  display: flex;
  flex-direction: flex-start;
  align-items: center;
`;

export const Percent = styled.div<PercentProps>`
  position: absolute;
  top: 25%;
  left: ${({ percent }) => {
    if (percent >= 95) {
      return 'calc(100% - 40px)';
    }
    return `${percent}%`;
  }};
  transform: ${({ percent }) => (percent < 5 ? 'none' : 'translateX(-50%)')};
  font-weight: bold;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black};
  white-space: nowrap;

  @media (max-width: ${({ theme }) => theme.media.tablet}px) {
    top: -20px;
    font-size: 12px;
  }
`;
